import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import KubernetesOutlinedSvg from "@ant-design/icons-svg/es/asn/KubernetesOutlined";
import AntdIcon from '../components/AntdIcon';
var KubernetesOutlined = function KubernetesOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: KubernetesOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(KubernetesOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'KubernetesOutlined';
}
export default RefIcon;